export const COLUMNS_METRICS = {
  budget: 'EstimatedBudget',
  impression: 'EstimatedImpressions',
  click: 'EstimatedClicks',
  conversion: 'EstimatedConversions',
  cost: 'EstimatedCost',
};

export const defaultColumnMetric = COLUMNS_METRICS.click;
